"use client";

import dynamic from "next/dynamic";

const ScrollCtaButton = dynamic(() => import("./ScrollCtaButton"), {
  ssr: false,
});

export default function HomepageScrollCta() {
  return <ScrollCtaButton />;
}
